module.exports = __webpack_public_path__ + "static/img/5.5a181e72.jpg";